import { merge } from '@/utils/nunchee-kit'
import { ISetting } from '@/types'

import {
  baseSettings as generalBaseSettings,
  envOverrides as generalEnvOverrides
} from './settings'

import * as fanatizSettings from '../apps/fanatiz/public'
import * as liga1Settings from '../apps/liga1/public'
import * as afaSettings from '../apps/afa/public'
import * as cdoSettings from '../apps/cdo/public'

export type UrlWithoutTrailingSlash = string & { __brand: 'UrlWithoutTrailingSlash' }

export function ensureValidUrlWithoutTrailingSlash(value: string): UrlWithoutTrailingSlash {
  try {
    const url = new URL(value)
    const cleanUrl = url.toString().replace(/\/+$/, '') // remove trailing slashes
    return cleanUrl as UrlWithoutTrailingSlash
  } catch (e) {
    throw new Error(`Invalid URL: ${value}`)
  }
}


const appCode = process.env.NEXT_PUBLIC_APP_CODE || 'fanatiz'

// A missing/typo'd NEXT_PUBLIC_APP_ENV used to silently fall back to the
// `development` block — which ships dev API/Optimizely/feature-flag config
// (incl. teamBranding: true). Validate against the known set and fail closed
// in production so a misconfigured prod build never boots with dev settings.
const KNOWN_ENVIRONMENTS = ['development', 'staging', 'production'] as const
const rawEnvironment = process.env.NEXT_PUBLIC_APP_ENV
if (rawEnvironment && !KNOWN_ENVIRONMENTS.includes(rawEnvironment as (typeof KNOWN_ENVIRONMENTS)[number])) {
  throw new Error(`Unknown NEXT_PUBLIC_APP_ENV: ${rawEnvironment}`)
}
if (!rawEnvironment && process.env.NODE_ENV === 'production') {
  throw new Error('NEXT_PUBLIC_APP_ENV must be set in production builds')
}
const environment = rawEnvironment || 'development'

const appSettings: Record<string, { baseSettings: Partial<ISetting>, envOverrides: Record<string, Partial<ISetting>> }> = {
  fanatiz: fanatizSettings,
  liga1: liga1Settings,
  afa: afaSettings,
  cdo: cdoSettings,
}

if (!appSettings[appCode]) {
  throw new Error(`No settings found for app code: ${appCode}`)
}

const appBaseSettings = appSettings[appCode].baseSettings as ISetting
const appEnvSpecificSettings = appSettings[appCode].envOverrides[environment]


let publicSettings: ISetting = merge(
  {},
  generalBaseSettings,
  generalEnvOverrides[environment],
  appBaseSettings,
  appEnvSpecificSettings
) as ISetting

if (process.env.NEXT_PUBLIC_CINEMATICS && publicSettings.api.cinematicsTag) {
  publicSettings.api.cinematicsTag = process.env.NEXT_PUBLIC_CINEMATICS
}

export default publicSettings